import React, { useEffect, useState } from 'react'
import Alert from 'components/atoms/Alert';
import CopyText from 'components/atoms/CopyText';
import PageHeader from 'components/molecules/PageHeader'
import AppTable from 'components/organisms/app-table';
import TableDataSpan from 'components/organisms/app-table/TableDataSpan';
import { BASE_URL, getRequest, loggedUser_baseURL } from 'services/http';
import { selectTableItem } from 'redux/app/app.action';
import { connect } from 'react-redux';
import moreIcon from '../../../assets/svg/more.svg'
import { useNavigate } from 'react-router-dom';
import useDebounce from 'components/molecules/useDebounce';
import useWindowSize from '../../../components/atoms/WindowWidth';

const Business = (props) => {
    const [loading, setLoading] = useState(false);
    const [errorState, setErrorState] = useState(false);
    const [businessList, setBusinessList] = useState<any>([]);
    const [totalBusinesses, setTotalBusinesses] = useState();
    const [pageNum, setPageNum] = useState(null);
    const [recordsPerPage] = useState(10);
    const [searchSelect, setSearchSelect] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('');
    const [selectedSearchKey, setSelectedSearchKey] = useState('');
    const [query, setQuery] = useState('');

    const navigate = useNavigate();
    // const {windowWidth, windowHeight, width, height} = useWindowSize();
    const debouncedQuery = useDebounce(query, 800);

    const searchParams = ["businessName", "businessId", "country"];

    const urlParam = `?size=${recordsPerPage}&page=${pageNum === null ? 0 : pageNum - 1}`;

    const main_url = debouncedQuery !== ''

        ? `${BASE_URL + loggedUser_baseURL + props.businessId + urlParam}&${selectedSearchKey}=${debouncedQuery}`

        : selectedStatus !== ''

            ? `${BASE_URL + loggedUser_baseURL + props.businessId + urlParam}&status=${selectedStatus}`

            : debouncedQuery !== '' && selectedStatus !== ''

                ? `${BASE_URL + loggedUser_baseURL + props.businessId + urlParam}&${selectedSearchKey}=${debouncedQuery}&status=${selectedStatus}`

                : debouncedQuery === ''

                    ? `${BASE_URL + loggedUser_baseURL + props.businessId + urlParam}`

                    : null;

    const getBusiness = async () => {
        setLoading(true);
        const res = await getRequest(main_url, {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${props.bearerToken}`
        });

        if (res?.data?.responseCode === '00') {
            // Alert('success', res?.data?.message);
            setBusinessList(res?.data?.data);
            setTotalBusinesses(res?.data?.totalNumberOfElements);

            setTimeout(() => setLoading(false), 1500);
        } else {
            setLoading(false);
            Alert('error', res?.data?.message);
        }
    }

    useEffect(() => {
        getBusiness();
    }, []);

    useEffect(() => {
        if (debouncedQuery !== '' || debouncedQuery === '' || selectedStatus !== '') {
            setTimeout(() => getBusiness(), 800);
        }
    }, [debouncedQuery, selectedStatus, props.refreshState, main_url]);


    const getCurrentPage = (pageNumber) => {
        setPageNum(pageNumber);
    }

    const businessStatus = [
        { label: "Approved", value: 'APPROVED' },
        { label: "New Business", value: 'NEW_BUSINESS' }
    ]

    const FilterData = [
        { titleText: 'Status', filters: businessStatus, selected: selectedStatus, setSelected: setSelectedStatus },
    ]

    const btnActionData = [
        { btnText: 'Button One', btnStyle: 'bg-SecondaryAccent5 text-DarkBg3 !text-sm', handleClick: () => Alert('info', 'Button One was clicked') },
        { btnText: 'Button Two', btnStyle: 'bg-DarkBg3 text-white !text-sm', handleClick: () => Alert('info', 'Button Two was clicked') },
    ]

    const columns = [
        {
            label: 'Business Name',
            render: (data) => <TableDataSpan
                onClick={() => navigate(`/dashboard/businesses/business_details/${data.businessId}`)}
                additionalClass='text-opacity-70 text-xs cursor-pointer'
                text={`${data.businessName}`}
            />
        },
        {
            label: 'Business ID',
            render: (data) => <TableDataSpan
                // onClick={() => navigate(`/dashboard/businesses/business_details/${data.businessId}`)}
                additionalClass="cursor-default"
            >
                <CopyText
                    text={`${data.businessId}`}
                    textStyle="text-opacity-70 text-xs mr-2 inline-block item-center"
                    mssgStyle='-right-3 -top-[18px] z-30'
                    imgStyle="w-4 h-4"
                />
            </TableDataSpan>
        },
        {
            label: 'Business Email',
            render: (data) => <TableDataSpan
                onClick={() => navigate(`/dashboard/businesses/business_details/${data.businessId}`)}
                text={!data.businessEmail ? 'Not Approved' : data.businessEmail}
                additionalClass='text-opacity-70 text-xs cursor-pointer'
            />
        },
        {
            label: 'Country',
            render: (data) => <TableDataSpan
                onClick={() => navigate(`/dashboard/businesses/business_details/${data.businessId}`)}
                text={`${data.country}`}
                additionalClass='text-opacity-70 text-xs cursor-pointer'
            />
        },
        {
            label: 'Status',
            render: (data) => <TableDataSpan
                onClick={() => navigate(`/dashboard/businesses/business_details/${data.businessId}`)}
                additionalClass='text-opacity-70 text-xs cursor-pointer'
            >
                <div className='flex items-center justify-start gap-2'>
                    <span className={`${data.status === 'APPROVED' ? 'bg-Green_Accent8 text-Success2' : data.status === 'UNAPPROVED' ? 'bg-DangerAccent5 text-Danger4' : 'bg-BackDrop_d_xs text-SecondaryAccent'} px-[10px] py-[5px] rounded-md`}>
                        {data.status?.split("_").join(" ")}
                    </span>
                </div>
            </TableDataSpan>
        }
    ]

    return (
        <div className='w-full min-h-[90vh] mobile:min-h-[83vh] h-fit flex flex-col justify-start gap-10'>
            <PageHeader
                pageTitle="Business List"
                // actionData={btnActionData}
                filterData={FilterData}
                searchInput={query}
                setSearchInput={setQuery}
                searchKey={selectedSearchKey}
                setSearchKey={setSelectedSearchKey}
                searchOpts={searchParams}
                loading={loading}
            />
            <AppTable
                columns={columns}
                data={businessList}
                itemsPerPage={recordsPerPage}
                loading={loading}
                errorState={errorState}
                dataLength={totalBusinesses}
                getCurrentPage={getCurrentPage}
            />
        </div>
    )
}

const mapStateToProps = state => ({
    userAuthRes: state.auth.user_authData,
    businessId: state.auth.user_authData.subPartnerId,
    bearerToken: state.auth.user_authData.token.token,
    refreshState: state.app.refreshState,
    businessData: state.app.businessData,
})

const mapDispatchToProps = dispatch => ({
    selectTableItem: (data: any) => dispatch(selectTableItem(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(Business);